import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#hausfrau

	{
		"sonstigesEinkommenMonatlich": schemaBigDecimal
	}

*/

export const schemaEuropaceHausfrau = z.object({
    sonstigesEinkommenMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceHausfrau = z.infer<typeof schemaEuropaceHausfrau>;
